export default __webpack_public_path__ + "static/error-cover-b69cd9da90c8f2ef537cfdcb54ebf483.jpg";